<template>
  <v-autocomplete
    :id="keyUpTargetId"
    ref="officeSelectorEltRef"
    v-model="selectedOptionValue"
    :items="modelList"
    clearable
    hide-no-data
    hide-selected
    return-object
    :loading="loading"
    :search-input.sync="searchQuery"
    item-value="id"
    :error="searchQuery && searchQuery.length < 2"
    :append-icon="loading ? '' : 'search'"
    item-text="querySearch"
    :label="`${label}`"
    persistent-hint
    :dense="dense"
    :outlined="outlined"
    :disabled="disabled"
    hide-details
    @click:append="requestData"
    @change="onOfficeSelectorFilterChange"
  >
    <template v-slot:selection="data">
      <v-chip
        small
        v-bind="data.attrs"
        :input-value="data.selected"
        close
        @click="data.select"
        @click:close="onRemove"
      >
        {{ data.item.title }}
      </v-chip>
    </template>
    <template v-slot:item="data">
      <template>
        <v-list-item-content class="ml-2">
          <v-list-item-title>
            {{ data.item.title }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ `${data.item.address}` }}
          </v-list-item-subtitle>
          <v-list-item-subtitle>
            {{ `${data.item.locality} (${data.item.province})` }}
          </v-list-item-subtitle>
          <v-list-item-subtitle>
            {{ `${data.item.organization}` }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
export default {
  name: 'WBDOfficeSelectorFilter',
  props: {
    remoteOptionValue: {
      type: [String, Object],
    },
    remoteList: {
      type: Array,
    },
    label: {
      type: String,
      default: 'Поиск объектов'
    },
    selectActive: Boolean,
    disabled: Boolean,
    dense: Boolean,
    outlined: Boolean

  },
  data () {
    return {
      keyUpTargetId: 'officeSelectorEltRef',
      loading: false,
      searchQuery: null,
      modelList: [],
      selectedOptionValue: null,
    }
  },
  computed: {
    ...mapGetters({
    }),
  },
  mounted () {
    window.addEventListener('keyup', (event) => {
      if (!(event && event.target && event.target.id === this.keyUpTargetId)) {
        return
      }
      if (event.keyCode === 13) {
        event.preventDefault()
        this.requestData()
      }
    })
  },
  created () {
    if (this.remoteOptionValue) {
      this.selectedOptionValue = this.remoteOptionValue
    }
    if (this.remoteList && this.remoteList.length) {
      this.modelList = this.remoteList
      this.selectedOptionValue = this.remoteList[0]
    }

    this.eventsBus.$on(this.eventNames.OFFICE_LIST_FILTER_RESET, () => {
      this.selectedOptionValue = null
      this.searchQuery = null
    })
  },
  methods: {
    ...mapMutations({
    }),
    ...mapActions({
    }),
    async requestData () {
      try {
        this.loading = true
        const params = { 'page[number]': 1, 'page[size]': 50, 'isSearch': '1' }
        if (this.searchQuery && this.searchQuery.trim() !== '') {
          params.searchQuery = this.searchQuery
        }
        if (this.selectActive) {
          params.status = 'active'
        }

        const list = await this.$store.dispatch(
          'organization/requestOfficeList',
          { params }

        )

        this.modelList = list.data.map((office) => ({
          ...office,
          querySearch: this.searchQuery
          // title: `${office.title} ${office.externalCode ? ` (${office.externalCode})` : ''}`
        }))

        setTimeout(() => {
          this.loading = false
        }, 1500)

        this.loading = false
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    onRemove () {
      this.selectedOptionValue = null
      this.onOfficeSelectorFilterChange()
    },
    onClear () {
      this.selectedOptionValue = null
      this.searchQuery = null
    },
    onOfficeSelectorFilterChange () {
      this.$emit(
        'onOfficeSelectorFilterChange',
        this.selectedOptionValue ? this.selectedOptionValue.id : null,
        this.selectedOptionValue
      )
    },
  }
}
</script>
